<template>
  <div>
    <div class="contact">
          <el-tooltip :hide-after="0" placement="left" effect="light">
            <div slot="content">
              <img src="../../assets/image/screen-shot.jpg" style="width: 124px"/>
<!--              <div>咨询电话</div>-->
<!--              <div>0731-88367088</div>-->
            </div>
            <el-button class="consult-btn"><i style="font-size: 24px" class="el-icon-chat-dot-round"></i>
              <div class="consult-title">
                在线咨询
              </div>
              </el-button>
          </el-tooltip>
          <el-tooltip placement="left" effect="light">
            <div class="content-phone" slot="content">
              <div>咨询电话</div>
              <div>0731-88367088</div>
            </div>
            <el-button class="consult-btn"><i style="font-size: 24px" class="el-icon-phone-outline"></i>
              <div class="consult-title">
                电话咨询
              </div>
              </el-button>
          </el-tooltip>
    </div>
  <div class="ZXJY">
    <div class="list" >
      <span class="remote" v-if="isVisible" :class="{show:isVisible}">Hello,欢迎来到互联网共享工厂！</span>
      <span class="remote" v-if="newIsVisible" :class="{show:newIsVisible}">如有业务需求，点击机器人在线咨询</span>
    </div>
    <span class="neirzi" v-if="!dialogTableVisible" @click="dialogTableVisible = !dialogTableVisible" style="cursor: pointer">智能客服</span>
    <img class="robortHover" v-if="!dialogTableVisible" @click="dialogTableVisible = !dialogTableVisible" src="../../assets/images/aiInnit.png" />


    <!--<div class="neirkuan">
      <div class="newNeirkuan">
        <el-row style="margin-top: 20px">
          <el-col :span="4" :offset="3"
            ><img src="../../assets/images/dianh.png"
          /></el-col>
          <el-col :span="15">客服电话</el-col>
        </el-row>
        <el-row>
          <el-col :span="15" :offset="7">0731-88367088</el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="4" :offset="3"
            ><img src="../../assets/images/gunaz.png"
          /></el-col>
          <el-col :span="15">关注公众号</el-col>
        </el-row>
        <el-row>
          <el-col :span="15" :offset="7"
            ><img src="../../assets/image/IMG_5062.jpg" width="72px"
          /></el-col>
        </el-row>
        <el-row style="margin-top: 20px; cursor: pointer">
          <el-col :span="4" :offset="3"
            ><img src="../../assets/images/bainj.png"
          /></el-col>
          <el-col :span="15"><span @click="yijts">在线咨询</span></el-col>
        </el-row>
      </div>
    </div>-->
    <!--咨询建议-->
    <el-dialog  :visible="dialogTableVisible" custom-class="robortDialogWrapper"
                :show-close="true"
                @close="close"
                :lock-scroll="false"
                top="66px"
                  width="1000px" :modal-append-to-body="false">
      <iframe :src="keSrc" style="width: 100%;height: 802px" frameborder="0"></iframe>
    </el-dialog>
  </div>
  </div>
</template>

<script>
export default {
  name: "Selectthe",
  data() {
    return {
      // 是否登录状态 http://localhost:8035/im/text/104eac.html
      lauyt: "",
      userName: "",
      usercell: "",
      dialogTableVisible:false,
      keSrc:'https://www.isoftfactory.com/kefu/im/text/104eac.html',
      isVisible:false,
      showDuration:3000,
      hideDuration:1000,
      showNewDuration:3000,
      hideNewDuration:2000,
      newIsVisible:false
    };
  },
  mounted() {
    this.toggleVisibility();
    // this.toggleNewVisibility();
  },
  created() {
    this.userName = sessionStorage.getItem("userName");
    this.usercell = sessionStorage.getItem("Mobilephone");
    if (this.userName && this.usercell) {
      this.keSrc = 'https://www.isoftfactory.com/kefu/im/text/104eac.html?username='+this.userName+'&uesrcell='+this.usercell;
    } else {
      this.keSrc = "https://www.isoftfactory.com/kefu/im/text/104eac.html";
    }
    //this.keSrc = 'https://www.isoftfactory.com/kefu/im/text/104eac.html ?username='+this.userName+'&uesrcell='+this.usercell;
    // console.log(this.userName,"this.userNamethis.userName");
    // console.log(this.usercell,"this.usercellthis.usercell");
  },
  methods: {
    toggleVisibility(){
      this.isVisible = true;
      setTimeout(()=>{
        this.newIsVisible = true;
      },1000)
      setTimeout(() => {
        this.isVisible = false;
        this.newIsVisible=false
        setTimeout(() => {
          this.toggleVisibility();
        }, this.hideDuration);
      }, this.showDuration);
    },
    close(){
      this.dialogTableVisible = !this.dialogTableVisible;
    },
    yijts() {
      if (this.userName && this.usercell) {
        window.open(`https://www.isoftfactory.com/kefu/im/text/104eac.html?username=${this.userName}&uesrcell=${this.usercell}`);
     } else {
        window.open("https://www.isoftfactory.com/kefu/im/text/104eac.html");
      }
    },
  },
  components: {},
};
</script>
<style scoped>
.contact{
  position:fixed;
  right: 10px;
  z-index: 200;
  bottom:2%;
  width: 64px;
  background:#fff;
  .consult-btn{
    font-size: 12px;
    padding:12px 10px;
    border: 1px solid #fff;
    margin-left:0px;
  .consult-title{
    margin-top:8px
  }
}
}
  /deep/ .robortDialogWrapper{ background: url("../../assets/images/kefubg.png")no-repeat; background-size: contain; position:relative;}
  /deep/ .robortDialogWrapper:after{content: '';display: inline-block;background: url("../../assets/images/aiInnit.png")no-repeat;width: 94px;height: 152px;position: fixed;right:13px;bottom:216px;}
/*  .robortDialogWrapper .el-dialog__header{display: none;}*/
  /deep/ .robortDialogWrapper .el-dialog__body{padding: 0;box-shadow:none;}
  .ZXJY .el-dialog__wrapper{ bottom: -90px;
    top: auto;
    right: 90px;
    left: auto;}

</style>
<style scoped>
.content-phone{
  font-size: 16px;
}
.robortHover:hover{
  animation: hover .4s linear;
  animation-fill-mode:forwards;
  transform:none;
  margin-left: 0;
}
.ZXJY >>> .el-dialog__headerbtn  .el-dialog__close{
  color: #ebb31e !important;
  font-size: 24px  !important;;
  font-weight: bolder  !important;;
}
@keyframes hover{
  from{
   margin-right: 0;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  to{
    margin-right: 40px;
    transform: rotate(0deg);
  }
}
.robortHover{
  transform: rotate(-44deg);
  margin-left: 43px;
}
.ZXJY {
  text-align: center;
  padding-top: 10px;
  position: fixed;
  z-index: 10;
 /* right: 10px;*/
  right:-36px;
  bottom: 160px;
  overflow:hidden;
 /*  height: 115px;*/
 /* background: #f9b600;*/
  /*box-shadow: -3px 0px 6px rgba(0, 0, 0, 0.16);*/
  opacity: 1;

  /*border-radius: 4px;*/
}

.list{
  /*animation: 7s rowup linear infinite normal;*/
  /*position: relative;*/
  /*-webkit-animation: 7s rowup linear infinite normal;*/
}
.remote{
  margin: 0 auto;
  display: block;
  width: auto;
  margin-right: 55px;
  margin-bottom: 13px;
  background: #90bbd2;
  height: 32px;
  line-height: 32px;text-align: center;padding: 0 10px;
  border-radius: 8px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(20px);
  opacity: 0;

}
.remote.show {
  opacity: 1;
  transform: translateY(0);
}
.neirzi {
  margin: 0 auto;
  display: block;
  margin-bottom: 13px;
  background: #f9b600;
  width: 80px;
  height: 32px;
  line-height: 32px;text-align: center;padding: 0 10px;
  border-radius: 8px;
}
.neirkuan {
  /* pointer-events: none; */
  text-align: left;
  padding: 10px;
  position: absolute;
  right: 42px;
  bottom: 0px;

  width: 198px;
  height: 264px;
  color: #666666;
  transition: 0.6s all;
  display: none;
}
.newNeirkuan {
  background: #fff;
  box-shadow: 1px 2px 6px rgba(0, 0, 0,.16);
  border-radius: 8px;
  height: 100%;
  padding-top: 10px;
}
.ZXJY:hover .neirkuan {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/xmgc/ZXJY.vue